import {
    Wrapper, Head, Btn, Intro, YT, BlueAgentFeatures, BlueAgentServices,
    AgentBackground,
    AgentImg,
    HeaderMeta,
    BlueAgentMeetSection,
    BlueAgentMeetForm, HeaderLogoHolder
} from "./theBlueAgent.Elements";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import FooterDivider from "../../components/FooterDivider";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useRef, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { Helmet } from "react-helmet";
import { useCallback } from "react";
import BlueAgentThumbnail from '../../assets/images/dark-agent-thumbnail.png';
import BlueAgentF1 from '../../assets/images/blue-agent/blue-agent-sc-01.jpeg';
import BlueAgentF2 from '../../assets/images/blue-agent/blue-agent-sc-02.jpeg';
import BlueAgentPlayIcon from '../../assets/images/dark-agent-play-icon.svg';
import BlueAgentMaximize from '../../assets/images/dark-agent-maximize.png';
import BlueAgentOptimize from '../../assets/images/dark-agent-optimize.png';
import BlueAgentSanitize from '../../assets/images/dark-agent-sanitize.png';
import IconLogo from '../../assets/images/blue-agent/logo.svg';
//icon bowl
import Iconbowl from '../../assets/images/blue-agent/icon-bowl.svg';
//icon calendar
import Iconcalendar from '../../assets/images/blue-agent/icon-calendar.svg';
//icon ai
import Iconai from '../../assets/images/blue-agent/icon-ai.svg';
//icon automation
import Iconautomation from '../../assets/images/blue-agent/icon-automation.svg';
//icon machine-speed
import Iconmachinespeed from '../../assets/images/blue-agent/icon-machine-speed.svg';
//icon clock-check
import Iconclockcheck from '../../assets/images/blue-agent/icon-clock-check.svg';
//icon 24-7
import Icon247 from '../../assets/images/blue-agent/icon-24-7.svg';
//icon monitor-full
import Iconmonitorfull from '../../assets/images/blue-agent/icon-monitor-full.svg';
//icon monitor-half
import Iconmonitorhalf from '../../assets/images/blue-agent/icon-monitor-half.svg';
//icon correlations
import Iconcorrelations from '../../assets/images/blue-agent/icon-correlations.svg';
//icon detect-powerful
import Icondetectpowerful from '../../assets/images/blue-agent/icon-detect-powerful.svg';
//icon detect
import Icondetect from '../../assets/images/blue-agent/icon-detect.svg';
//icon manual-management
import Iconmanualmanagement from '../../assets/images/blue-agent/icon-manual-management.svg';
import { useNavigate } from "react-router-dom";
import {
    AdvisoryBackground,
    AdvisoryCover,
    AdvisoryImg,
    AdvisoryTextBody,
    AdvisoryTextTitle,
    AdvisoryTitle,
    CornImg,
    CoverBody,
    CoverTitle
} from "../advisory/AdvisoryElement";
import { FaCheckCircle } from "react-icons/fa";
import { CornMobile, ScrollTop } from "../home/HomeElements";
import scrollTopIcon from "../../assets/images/ScrolltoTopIcon.png";
import { FieldRow, FormRow } from "../contactUs/ContactUsElement";
import { Input } from "@mui/material";
import { SpanPolicy } from "../../components/EmailForm/EmailFormElements";
import agent from "../../utils";
import { toast } from "react-toastify";
import { isValidEmail } from '../../helpers/email-helper';
import BlueAgentLogoWhite from "../../assets/images/blue-agent/blue-agent-logo-white.png";
import CaptchaDialog from "../../common/captchaDialoge";
import ThanksDialog from "../../common/thanksDialog";
import { Link } from 'react-router-dom';
import parse from "html-react-parser";
import { MESSAGES } from "../../constants/messages";
import ComparisonTable from "../../components/ComparisonTable";

const TheBlueAgent = ({ isScrolled, setReshowDialog }) => {
    const isMobile = useMediaQuery({ query: `(max-width: 800px)` });
    const [playVideo, setPlayVideo] = useState(false);
    const targetSection = useSelector((state) => state.scroll.targetSection);
    const navigate = useNavigate();

    const [name, setName] = useState(null);
    const [email, setEmail] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [messageValidation, setMessageValidation] = useState(false);

    const fieldsStyle = { flex: '1 1 auto', marginTop: '3vh' };
    //captcha
    const [loading, setLoading] = useState(false);
    const [captchaKey, setCaptchaKey] = useState(null);
    const [captchaOpen, setCaptchaOpen] = useState(false);
    const [thanksOpen, setThanksOpen] = useState(false);
    const invalidEmailMessage = "Email is not valid";
    const leftRows = [
        { icon: Icon247, text: "Continuous 24/7 autonomous threat hunting" },
        { icon: Iconmonitorfull, text: "Actively hunts across all severities, not just high and critical" },
        { icon: Iconai, text: "AI correlation across endpoint, network, cloud, and identity" },
        { icon: Icondetectpowerful, text: "Early detection of silent breaches before escalation" },
        { icon: Iconautomation, text: "Automated case management cuts human error and ensures critical alerts get escalated" },
        { icon: Iconmachinespeed, text: "Machine-speed analysis and response" }
    ];

    const rightRows = [
        { icon: Iconcalendar, text: "Periodic (weekly/monthly) hunting cycles" },
        { icon: Iconmonitorhalf, text: "Monitors all severities, but hunting and alert centralization prioritize high and critical" },
        { icon: Iconcorrelations, text: "Limited correlation across endpoint, network, cloud, and identity" },
        { icon: Icondetect, text: "Detection typically occurs after compromise impact" },
        { icon: Iconmanualmanagement, text: "Manual case management, with a higher risk of missed or delayed escalation" },
        { icon: Iconclockcheck, text: "Analysis and response paced by analyst availability" }
    ];
    const sxProps = {
        '& label.Mui-focused': {
            color: 'black',
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: '#002F87',
        },
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: '#002F87',
            },
            '&:hover fieldset': {
                borderColor: '#002F87',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#002F87',
            }
        },
        '& .MuiInputBase-input': {
            width: '100%',
            fontSize: '15px'
        }
    };

    const features = [
        {
            id: 1,
            title: "Contextual Event Analysis",
            description: "Organizes network activity into behavioral groups and measures deviations to accurately identify anomalous events.",
            featureImg: BlueAgentF1,
        },
        {
            id: 2,
            title: "Anomaly Detection",
            description: "Correlates user activity and event logs to detect abnormal behavior and highlight high-risk events for security teams.",
            featureImg: BlueAgentF2,
        }
    ];

    useEffect(() => {
        if (targetSection === null) {
            window.scrollTo(0, 0);
        }
    }, [])

    const submitDemo = () => {
        if (isValidEmail(email)) {
            setIsLoading(true);
            agent.BlueAgentDemos.postEmail({
                "email": email,
                "g-recaptcha-response": captchaKey
            }).then(() => {
                setEmail("");
                setCaptchaOpen(false);
                toast.success(<>{parse(MESSAGES.SUCCESS.DEMO_FORM_SUBMITTED)}</>);
            }).catch(() => {
                toast.error("An error occurred")
            }).finally(() => {
                setIsLoading(false);
                setMessageValidation(null);
            })
        } else {
            setMessageValidation(invalidEmailMessage);
        }
    }
    const handleSubmit = () => {
        if (localStorage.getItem('cookie') !== '1')
            setReshowDialog(true);
        else {
            if (isValidEmail(email)) {
                setCaptchaOpen(true);
            } else {
                setMessageValidation(invalidEmailMessage);
            }
        }
    }
    return <>
        <Helmet>
            <title>The Blue Agent</title>
            <meta name="robots" content="nofollow"></meta>
            <meta name="description"
                content="Your Ultimate Digital Risk and Threat Intel Ally" />
        </Helmet>
        <Wrapper>
            <AgentBackground>
                <AgentImg />
                <HeaderMeta className={'header-meta'}>
                    <div className="meta-intro">
                        Meet The Blue Agent, Our Newest Autonomous SOC AI Agent
                    </div>
                    <div className="meta-logo-holder">
                        <img alt={''} className={'img-fluid'} src={BlueAgentLogoWhite} />
                        <span>The Blue Agent</span>
                    </div>
                    <div className="meta-body">
                        Never Stop Threat Hunting
                    </div>
                </HeaderMeta>
                <ScrollTop isScrolled={isScrolled} src={scrollTopIcon} onClick={() => {
                    window.scrollTo(0, 0)
                }} />
            </AgentBackground>
            <BlueAgentMeetSection>
                <CornImg>
                    <svg width="5vw" height="64" viewBox="0 0 95 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M93.2442 59.4236C92.3635 60.5719 91.0927 61.5253 89.5607 62.187C88.0286 62.8487 86.29 63.1951 84.5213 63.191H10.7127C8.94399 63.196 7.20501 62.8505 5.67236 62.1895C4.13972 61.5286 2.86799 60.5758 1.98633 59.4279C1.10466 58.2799 0.644456 56.9778 0.652446 55.6537C0.660436 54.3295 1.13634 53.0306 2.03182 51.8887L38.8942 4.16745C39.7767 3.01972 41.0476 2.06639 42.579 1.40351C44.1104 0.740626 45.8481 0.391602 47.617 0.391602C49.386 0.391602 51.1237 0.740626 52.655 1.40351C54.1864 2.06639 55.4574 3.01972 56.3399 4.16745L93.2022 51.8887C94.1045 53.0281 94.584 54.3272 94.5914 55.6518C94.5988 56.9765 94.1337 58.2785 93.2442 59.4236Z"
                            fill="url(#paint0_linear_51_664)" style={{ mixBlendMode: 'normal' }} />
                        <defs>
                            <linearGradient id="paint0_linear_51_664" x1="0.652344" y1="31.7913" x2="94.5915"
                                y2="31.7913" gradientUnits="userSpaceOnUse">
                                <stop offset="0.253125" stopColor="#bcbcbc" />
                                <stop offset="0.711458" stopColor="#bababa" />
                            </linearGradient>
                        </defs>
                    </svg>
                </CornImg>
                <CornMobile>
                    <svg width="46" height="40" viewBox="0 0 46 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M45.3402 37.0986C44.909 37.8203 44.2867 38.4194 43.5365 38.8353C42.7863 39.2511 41.9349 39.4688 41.0689 39.4663H4.92635C4.06024 39.4694 3.2087 39.2522 2.4582 38.8369C1.70769 38.4215 1.08496 37.8227 0.653222 37.1013C0.22149 36.3799 -0.00386255 35.5616 5.00943e-05 34.7294C0.00396274 33.8973 0.237 33.0809 0.675499 32.3633L18.7262 2.37293C19.1584 1.65164 19.7807 1.05252 20.5306 0.635934C21.2805 0.219344 22.1314 0 22.9976 0C23.8638 0 24.7147 0.219344 25.4646 0.635934C26.2145 1.05252 26.8369 1.65164 27.269 2.37293L45.3197 32.3633C45.7615 33.0794 45.9963 33.8958 46 34.7283C46.0036 35.5607 45.7758 36.379 45.3402 37.0986Z"
                            fill="url(#paint0_linear_1_662)" style={{ mixBlendMode: 'normal' }} />
                        <defs>
                            <linearGradient id="paint0_linear_1_662" x1="0" y1="19.7332" x2="46" y2="19.7332"
                                gradientUnits="userSpaceOnUse">
                                <stop stop-color="#bcbcbc" />
                                <stop offset="1" stop-color="#bababa" />
                            </linearGradient>
                        </defs>
                    </svg>
                </CornMobile>
                <div className="title">
                    Blue Agent is an AI-powered SOC agent that scales expert threat hunting into an always-on autonomous operation.
                    <br /><br />
                    Operating continuously across endpoint, network, cloud, and identity layers, it analyzes and correlates telemetry to uncover subtle indicators of compromise before the escalate into incidents.
                    <br /><br />
                    With persistent visibility, automated incident and case management, and machine-speed investigations, Blue Agent helps security teams identify the threats traditional defenses miss.
                </div>
            </BlueAgentMeetSection>
            <BlueAgentFeatures>
                {features.map((feature,i) => (
                    <div className={i % 2 === 0 ? "row" : "row flex-row-reverse"} key={feature.id}>
                        <div className="col">
                            <div className="title">{feature.title}</div>
                            <div className="description">{feature.description}</div>
                        </div>
                        <div className="col"><img className="img" alt={''} src={feature.featureImg} /></div>
                    </div>
                ))}
            </BlueAgentFeatures>
            <BlueAgentServices>
                <div className="row">
                    <ComparisonTable
                        leftTitle="Blue Agent Autonomous Threat Hunting Mesh"
                        leftIcon={IconLogo}
                        rightTitle="Traditional Security Operations"
                        rightIcon={Iconbowl}
                        leftRows={leftRows}
                        rightRows={rightRows}
                        leftBg={'linear-gradient(90deg, #274D95 0%, #090C19 103%)'}
                        rightBg={'linear-gradient(90deg, #090C19 0%, #000000 100%)'}
                        showRecommendedBadge
                        recommendedBadgeText="Recommended"
                        recommendedBadgeIcon={<FaCheckCircle size={16} />}
                    />
                </div>

                <CaptchaDialog
                    loading={loading}
                    open={captchaOpen}
                    setOpen={setCaptchaOpen}
                    submitHandler={submitDemo}
                    btnText={"SUBMIT"}
                    setCaptchaKey={setCaptchaKey}
                />
                <ThanksDialog
                    open={thanksOpen}
                    setOpen={setThanksOpen}
                    title={"Thank You For Your Message!"}
                />
                <BlueAgentMeetForm width="90vw" flexDirection="row" padding="50px">
                    <div>
                        <div className="form-title">
                            Meet the Blue Agent.
                        </div>
                        <div className="form-comment">
                            Leave your email to get a free demo!
                        </div>
                    </div>
                    <div>
                        <FormRow compact>
                            <FieldRow>
                                <Input
                                    placeholder="Email"
                                    value={email}
                                    onChange={event => {
                                        setEmail(event.target.value?.trim());
                                        setMessageValidation(null);
                                    }}
                                    style={fieldsStyle}
                                    sx={sxProps} />
                            </FieldRow>
                        </FormRow>
                        <div className="form-error">{messageValidation ?? ''}</div>
                        <div className="form-message">
                            By submitting your email address, you agree to receiving emails from potech and acknowledge
                            our <SpanPolicy style={{ fontStyle: 'normal' }} target="_blank" href="/privacy_notice">Privacy
                                Policy</SpanPolicy>.
                        </div>
                        <button className="form-button" onClick={handleSubmit} disabled={isLoading}>
                            REQUEST DEMO
                        </button>
                    </div>
                </BlueAgentMeetForm>
            </BlueAgentServices>
        </Wrapper>
    </>
}

export default TheBlueAgent;
